// Query-key factory for the admin Interview Wording editor. Lives in its own
// *Keys file so the stale-after-save convention recognises it, and every
// mutation invalidates the whole surface by the `all` prefix: a draft, a
// publish or a revert changes the editor, the version list and an item's
// change log together.

export const interviewWordingKeys = {
  all: ["interview-wording"] as const,
  editor: () => ["interview-wording", "editor"] as const,
  history: (blockKey: string) => ["interview-wording", "history", blockKey] as const,
};
